import { useAntDesignTheme } from './useAntDesignTheme';

export const useScrollbarStyles = () => {
    // const lightThumb = 'rgba(0, 0, 0, 0.25)';
    // const lightThumbHover = 'rgba(0, 0, 0, 0.45)';

    // const darkThumb = 'rgba(255, 255, 255, 0.35)';
    // const darkThumbHover = 'rgba(255, 255, 255, 0.55)';

    const { token } = useAntDesignTheme();

    const thumb = token.colorBorder;
    const thumbHover = token.colorBorder;

    return (
        <style>
            {`
        /* Firefox */
        * {
          scrollbar-width: thin;
          scrollbar-color: ${thumb} transparent;
        }

        /* WebKit (Chrome, Safari, Edge) */
        ::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }
        ::-webkit-scrollbar-track {
          background: transparent;
        }
        ::-webkit-scrollbar-thumb {
          background-color: ${thumb};
          border-radius: 3px;
          transition: background 0.2s;
        }
        ::-webkit-scrollbar-thumb:hover {
          background-color: ${thumbHover};
        }
      `}
        </style>
    );
};
